import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import MenuProperty from './MenuProperty'
export default MenuProperty.extend({
    props: {
        text: {
            type: String,
            required: false,
            default: null
        },
        only: {
            type: Array,
            required: false,
            default: () => new Array
        },
        except: {
            type: Array,
            required: false,
            default: () => new Array
        },
        classes: {
            type: String,
            required: false,
            default: 'classes'
        },
        styles: {
            type: String,
            required: false,
            default: 'styles'
        }
    },

    components: {VueSlider},

    computed: {
        device() {
            return this.$store.getters['pageModule/device']
        },

        elementAssets() {
          return this.$store.getters[`${this.module}/assets`](this.element, this.parentModule)
        },
    },

    methods: {
        elementClasses(classes) {
          return this.$store.getters[`${this.module}/styles`](this.element, classes, this.parentModule)
        },

        elementStyles(styles) {
          return this.$store.getters[`${this.module}/styles`](this.element, styles, this.parentModule)
        },
    }
})
